module.exports = __webpack_public_path__ + "media/components/country-flag/static/rw-28a429f1bc82ff5eff2721ff86a997c2.svg";